import { render, staticRenderFns } from "./AdManagementPolicy.vue?vue&type=template&id=834c816e&scoped=true&"
import script from "./AdManagementPolicy.vue?vue&type=script&lang=js&"
export * from "./AdManagementPolicy.vue?vue&type=script&lang=js&"
import style0 from "./AdManagementPolicy.vue?vue&type=style&index=0&id=834c816e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834c816e",
  null
  
)

export default component.exports